<template>
  <div class="">
      <br />
      <v-card>

        <v-card-title primary-title>
              <div>
                This will login as {{kid.name}} and show you all the recent
                changes made to their Market.
              </div>

        </v-card-title>

       <v-card-actions>
         <v-spacer></v-spacer>
         <v-btn @click="showRecentActivity" :loading="inprogress" flat color="accent">
           Show Recent Activity
          </v-btn>
        </v-card-actions>

        <div v-if="errMessage" class="error--text">
          {{ errMessage }}
        </div>
      </v-card>
</div>

</template>

<script>

import {mapState} from 'vuex'
// import utils from '../../../utils.ts'
import firebase from 'firebase/app'
import config from '../../config.js'

export default {
  name: 'GotoTransactions',
  components: {
  },
  computed: {
    ...mapState({
    })

  },
  props: {
    kid: {
      required: true,
      type: Object
    }

  },
  data () {
    return {
      inprogress: false,
      errMessage: null
    }
  },
  methods: {
    showRecentActivity: async function () {
      console.log('Login as kid:' + JSON.stringify(this.kid))

      this.errMessage = null

      this.inprogress = true

      // Call the async function to reset flag
      try {
        const getCustomLoginToken = config.getFunctions().httpsCallable('getCustomLoginToken')
        const loginToken = await getCustomLoginToken(this.kid)

        // Store the parent token so we can come back (at least within an hour)
        this.$store.commit('parent/storeParentToken', loginToken.data.parent)


        // Stop watching stuff before moving on.
        await this.$store.dispatch('parent/stopWatchingParent')

        // Now login with the token
        await firebase.auth().signInWithCustomToken(loginToken.data.kid)

        // Go to the kid's main page
        this.$router.push({name: 'RecentActivity'})
      } catch (err) {
        console.error('Error logging in as a kid: ' + JSON.stringify(err))
        this.errMessage = 'Error logging in as a kid: ' + err
      }
      this.inprogress = false
    }

  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>

</style>
